import React, { Component } from 'react'
import { connect } from 'react-redux'
import autobind from 'autobind-decorator'
import "whatwg-fetch"
import update from 'immutability-helper'
import { codes } from 'keycode'

import { isDescendant } from '../../utils/DomHelper'
import FilterList from '../../constants/plugins/FilterList'
import PluginDetailForm from "./PluginDetailForm"
import {jsonResponseHandler} from "../../utils/FetchHelper"
import * as SaveStatus from '../../constants/SaveStatus'
import { changePlugin } from '../../actions/plugins'
import TSubmitButtonForm from "../common/TSubmitButtonForm";
import * as PluginSaveStatusLabel from '../../constants/PluginSaveStatusLabel'
import LoadingBox from "../common/LoadingBox";
import WindowEventHelper from "../../lib/WindowEventHelper";
import {changeActivePlugins} from "../../actions/setting/blog";
import {addPrefix} from "../../utils/UriUtil";

@connect(state => ({}), dispatch => ({
	handleChangePlugin(plugin) {
		dispatch(changePlugin(plugin))
        dispatch(changeActivePlugins(plugin))
    },
    dispatch
}))
class PluginDetail extends Component {

	constructor(props, context) {
		super(props, context)
		this.state = {
			initialized: false,
			data: {
				validated: false
			},
			saving: props.plugin.active? SaveStatus.READY : SaveStatus.CAN_SUBMIT,
			top: '150px',
		}
	}

	componentDidMount() {
		const { plugin, onClose, dispatch } = this.props;

		document.body.className = "scroll_hide"
		WindowEventHelper.add("keydown", this.handleKeyDown)

		fetch(addPrefix(`/manage/plugin/${plugin.name}.json`), {
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json'
			}
		})
			.then(jsonResponseHandler(dispatch))
			.then(r => r.json())
			.then(data => {
				this.setState({
					data: data,
					initialized: true
				})
			})
			.catch(e => {
				console.error(e)
				onClose()
			})
	}

    componentDidUpdate() {
        const innerLayer = document.getElementsByClassName('inner_blog_layer')[0];
        if (typeof innerLayer != 'undefined' && document.documentElement.clientHeight > innerLayer.scrollHeight + 140) {
            if (this.state.top != (document.documentElement.clientHeight-innerLayer.scrollHeight)/2+'px')
        		this.setState({
             	   top: (document.documentElement.clientHeight-innerLayer.scrollHeight)/2+'px'
        		})
        }
        else {
            if (this.state.top != '50px')
	        	this.setState({
	                top: '50px'
	            })
        }
	}

	componentWillUnmount() {
		document.body.className = ""
		WindowEventHelper.remove("keydown", this.handleKeyDown)
	}

	@autobind
	handleKeyDown(e) {
		const { keyCode, target } = e
		const { onClose } = this.props

		const EXCLUDE_NODES = [
			"INPUT",
			"TEXTAREA",
			"BUTTON"
		]

		if (EXCLUDE_NODES.find(i => i === target.nodeName.toUpperCase())) {
			return
		}

		if (keyCode === codes.esc) {
		 	onClose()
		}
	}

    @autobind
	changeSaving(saving) {
		this.setState({
			saving: saving
		})
	}

	@autobind
	handleDataChange(data) {
	  console.log(data)
		this.setState({
			data: data,
      saving: data.validated? SaveStatus.CAN_SUBMIT : SaveStatus.READY
		})
	}

	@autobind
	handleClose(e) {
		const { onClose } = this.props
		const { layer } = this.refs
		if (!isDescendant(layer, e.target)) {
			onClose()
		}
	}

	@autobind
	handleActivate(e) {
		e.preventDefault()

		const { plugin, handleChangePlugin, onClose, dispatch } = this.props
		const { data, saving } = this.state

		this.changeSaving(SaveStatus.DOING)
		fetch(addPrefix(`/manage/plugin/${plugin.name}.json`), {
			method: 'post',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				setting: data.setting
			})
		})
			.then(jsonResponseHandler(dispatch))
			.then(r => {
				handleChangePlugin(update(plugin, {
					channelUrl: {
						$set: plugin.name === 'KakaoStoryPlus'? `https://story.kakao.com/ch/${data.setting.oAuthConsumerInfo.extra}` : null
					},
					active: {
						$set: true
					}
				}))
				this.changeSaving(SaveStatus.DONE)
				onClose();
                window.scrollTo(0, 0)
			})
			.catch(e => {
			  if (plugin.name === 'GoogleSearchConsole') {
			    const clone = Object.assign({}, data)
          clone.setting.googleCredits = {}
          clone.setting.googleSiteVerificationCode = null

          this.setState({
            data: clone,
            saving: SaveStatus.READY
          })
			    alert('토큰이 만료되었습니다. 계정 연결하기를 다시 진행해주세요.')
        } else {
          this.changeSaving(saving)
        }
			})
	}

	@autobind
	handleDeactivate(e) {
		e.preventDefault()

		const { plugin, handleChangePlugin, onClose, dispatch } = this.props
		const { saving } = this.state

		this.changeSaving(SaveStatus.DOING)
		fetch(addPrefix(`/manage/plugin/${plugin.name}.json`), {
			method: 'delete',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json'
			}
		})
			.then(jsonResponseHandler(dispatch))
			.then(r => {
				handleChangePlugin(update(plugin, {
					channelUrl: {
						$set: null
					},
					active: {
						$set: false
					}
				}))
				this.changeSaving(SaveStatus.DONE)
				onClose()
			})
			.catch(e => {
				console.error(e)
				this.changeSaving(saving)
			})
	}

	render() {
		const { plugin } = this.props
		const { initialized, data, saving, top } = this.state

		return (
			<div className="container_layer" onClick={this.handleClose}>
				{ !initialized && <LoadingBox/> }
				{ initialized &&
				<div ref="layer" className="blog_layer" style={{ top:top}}>
					<div className="inner_blog_layer inner_blog_layer3">
						<div className="wrap_set">
							<strong className="tit_popup">

								{ plugin.title }

								{ plugin.pc && <span className="txt_cate">PC</span> }

								{ plugin.mobile && <span className="txt_cate">모바일</span> }

								{ plugin.category.map((category, index) => {
									let filter = FilterList.find(filter => filter.category === category)
									if (filter && filter.category !== 'recommand') {
										return (
											<span key={index} className="txt_cate">{filter.label}</span>
										)
									}
								})}

								<span className="txt_producer">
									<span className="txt_other">제작자</span>
									{ plugin.author }
								</span>
							</strong>

							<div className="wrap_thumb">
								<img src={ plugin.coverImage } width="800" height="360" className="thumb_img" alt={ plugin.title } />
							</div>

							<form onSubmit={this.handleActivate} onReset={this.handleDeactivate}>
								{initialized &&
                  <PluginDetailForm
                    plugin={plugin} data={data}
                    onChange={this.handleDataChange}
                    saveButton={()=>
                      <fieldset>
                        <legend className="screen_out">적용 버튼</legend>
                        {plugin.link &&
                          <a href={ plugin.link } target="_blank" className="link_etc">
                            자세히 보기<span className="ico_blog ico_blank" />
                          </a>
                        }
                        {plugin.active && saving !== SaveStatus.DOING &&
                          <button type="reset" className="btn_remove">해제</button>
                        }
                        <TSubmitButtonForm
                          type="submit"
                          active={plugin.active}
                          status={saving}
                          label={PluginSaveStatusLabel}
                        />
                      </fieldset>
                    }
                  />
								}
							</form>
						</div>
					</div>
				</div>
				}
				<label className="lab_btn lab_close">
					<span className="ico_blog">레이어 닫기</span>
					<input type="button" className="btn_g" value="닫기" onClick={this.handleClose} />
				</label>
			</div>
		)
	}
}

export default PluginDetail
